export enum MessagesEnum {
  NONE_OF_THE_ABOVE = 'NONE_OF_THE_ABOVE',
  SERVICE_NOT_FOUND = 'SERVICE_NOT_FOUND',
  ASK_FOR_LOCATION = 'ASK_FOR_LOCATION',
  ASK_FOR_LOCATION_NAME = 'ASK_FOR_LOCATION_NAME',
  REQUESTING_SERVICE = 'REQUESTING_SERVICE',
  GREETING = 'GREETING',
  GREETING_NEW_USERS = 'GREETING_NEW_USERS',
  CANCELED = 'CANCELED',
  NO_LOCATION_FOUND = 'NO_LOCATION_FOUND',
  NO_LOCATION_NAME_FOUND = 'NO_LOCATION_NAME_FOUND',
  ASK_FOR_CANCEL_WHILE_FIND_DRIVER = 'ASK_FOR_CANCEL_WHILE_FIND_DRIVER',
  ERROR_CREATING_SERVICE = 'ERROR_CREATING_SERVICE',
  ERROR_WHILE_PROCESSING = 'ERROR_WHILE_PROCESSING',
  SERVICE_IN_PROGRESS = 'SERVICE_IN_PROGRESS',
  SERVICE_ASSIGNED = 'SERVICE_ASSIGNED',
  SERVICE_CREATED = 'SERVICE_CREATED',
  MESSAGE_TYPE_NOT_SUPPORTED = 'MESSAGE_TYPE_NOT_SUPPORTED',
  SERVICE_COMPLETED = 'SERVICE_COMPLETED',
  ASK_FOR_NAME = 'ASK_FOR_NAME',
  DRIVER_ARRIVED = 'DRIVER_ARRIVED',
  ASK_FOR_CANCEL_WHILE_WAIT_DRIVER = 'ASK_FOR_CANCEL_WHILE_WAIT_DRIVER',
  ASK_FOR_CANCEL = 'ASK_FOR_CANCEL',
  BAD_AGREEMENT = 'BAD_AGREEMENT',
  DEFAULT_MESSAGE = 'DEFAULT_MESSAGE',
  NEW_USER_ASK_FOR_COMMENT = 'NEW_USER_ASK_FOR_COMMENT',
  NEW_USER_ASK_FOR_PLACE = 'NEW_USER_ASK_FOR_PLACE',
  FULL_CLIENT = 'FULL_CLIENT',
}